export const baseUrl = process.env.NEXT_PUBLIC_API_URL || process.env.REACT_APP_API_URL
export const liveOdds = process.env.NEXT_PUBLIC_LIVE_ODD || process.env.REACT_APP_LIVE_ODD
export const liveScoreToday = process.env.NEXT_PUBLIC_LIVESCORE || process.env.REACT_APP_LIVESCORE
export const apiKey = process.env.NEXT_PUBLIC_API_KEY || process.env.REACT_APP_API_KEY
